"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/ImageGroupMessage/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _imageGrid = require('shared/utils/imageGrid');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _message = require('shared/enum/message');
var _consent = require('shared/services/consent');
var _uploadProgress = require('shared/services/uploadProgress');
var _fetcher = require('web/services/fetcher'); var _fetcher2 = _interopRequireDefault(_fetcher);
var _Tooltip = require('web/components/Tooltip');
var _RichMessageWrapper = require('../RichMessageWrapper'); var _RichMessageWrapper2 = _interopRequireDefault(_RichMessageWrapper);
var _ContextMenu = require('../RichMessageWrapper/ContextMenu'); var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
var _ReactionChips = require('../RichMessageWrapper/ReactionChips'); var _ReactionChips2 = _interopRequireDefault(_ReactionChips);
var _ReactionPicker = require('../RichMessageWrapper/ReactionPicker'); var _ReactionPicker2 = _interopRequireDefault(_ReactionPicker);
var _DerivativeImage = require('../FileMessage/DerivativeImage'); var _DerivativeImage2 = _interopRequireDefault(_DerivativeImage);
var _useFileDownload = require('../FileMessage/useFileDownload'); var _useFileDownload2 = _interopRequireDefault(_useFileDownload);
var _VideoOverlay = require('../FileMessage/VideoOverlay'); var _VideoOverlay2 = _interopRequireDefault(_VideoOverlay);
var _CaptionPart = require('../FileMessage/CaptionPart'); var _CaptionPart2 = _interopRequireDefault(_CaptionPart);

var _Lightbox = require('./Lightbox'); var _Lightbox2 = _interopRequireDefault(_Lightbox);






const isDelivered = (row) =>
  !row.deliveryStatus || row.deliveryStatus === _message.deliveryStatus.DELIVERED

const requestFileLinks = (fileKey) =>
  _fetcher2.default.call(void 0, '/get_file_link?key=' + fileKey, 'GET', null).catch(() => null)

































/* An image of the send still uploading, or failed: its progress and Cancel,
 * or why it failed and Retry, over its tile (as a lone file shows them). */
const TileUploadState = ({ row, messageKey, isFromMe, onRetry, onAbort }) => {
  const progress = _uploadProgress.useUploadProgress.call(void 0, isFromMe ? messageKey : undefined)
  const hasFailed = row.deliveryStatus === _message.deliveryStatus.FAILED
  const canRetry = _optionalChain([progress, 'optionalAccess', _ => _.phase]) !== 'failed' || progress.retryable
  const handleRetry = _react.useCallback.call(void 0, 
    () => _optionalChain([onRetry, 'optionalCall', _2 => _2(messageKey, _Lightbox.getFileKey.call(void 0, row))]),
    [onRetry, messageKey, row],
  )
  const handleAbort = _react.useCallback.call(void 0, 
    () => _optionalChain([onAbort, 'optionalCall', _3 => _3(messageKey, { pruneTimeout: 1200 })]),
    [onAbort, messageKey],
  )

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'image-group--upload', { 'image-group--upload-failed': hasFailed }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      , _react2.default.createElement('span', { className: "image-group--upload-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
        ,  hasFailed ? _uploadProgress.uploadFailureLabel.call(void 0, _optionalChain([progress, 'optionalAccess', _4 => _4.failure])) : _nullishCoalesce(_uploadProgress.uploadStatusLabel.call(void 0, progress), () => ( 'Sending…')) 
      )
      ,  hasFailed
        ? canRetry && onRetry && (
          _react2.default.createElement('button', { type: "button", className: "image-group--upload-action", onClick: handleRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Retry"

          )
        )
        : isFromMe && onAbort && _optionalChain([progress, 'optionalAccess', _5 => _5.phase]) !== 'finishing' && (
          _react2.default.createElement('button', {
            type: "button",
            className: "image-group--upload-action",
            onClick: handleAbort,
            'aria-label': "Cancel upload" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}

            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}, "close")
          )
        )
      
    )
  )
}

/* One image of the group, with its own reactions and actions. */
const ImageTile = ({
  row,
  index,
  count,
  isFullWidth,
  moreCount,
  isFromMe,
  currentUserKey,
  subscribers,
  conversationKey,
  readOnly,
  recallOnlyAwaitingConsent,
  onOpen,
  onExpand,
  onAddReaction,
  onRemoveReaction,
  onReply,
  onDelete,
  onCopyMessageLink,
  onDownload,
  onRetry,
  onAbort,
}) => {
  const messageKey = row.MessageKey 
  const delivered = isDelivered(row)
  const fileKey = _Lightbox.getFileKey.call(void 0, row)
  const [isMenuOpen, setIsMenuOpen] = _react.useState.call(void 0, false)
  const [isPickerOpen, setIsPickerOpen] = _react.useState.call(void 0, false)
  const openMenu = _react.useCallback.call(void 0, () => setIsMenuOpen(true), [])
  const closeMenu = _react.useCallback.call(void 0, () => setIsMenuOpen(false), [])
  const openPicker = _react.useCallback.call(void 0, () => setIsPickerOpen(true), [])
  const closePicker = _react.useCallback.call(void 0, () => setIsPickerOpen(false), [])

  const requestFreshThumbnail = _react.useCallback.call(void 0, 
    () => requestFileLinks(fileKey).then(response => _optionalChain([response, 'optionalAccess', _6 => _6.ThumbnailLink]) || null),
    [fileKey],
  )
  // An image still uploading has no original to open yet.
  const handleOpen = _react.useCallback.call(void 0, 
    () => moreCount ? onExpand() : delivered && onOpen(messageKey),
    [moreCount, onExpand, onOpen, messageKey, delivered],
  )
  const handleSelectReaction = _react.useCallback.call(void 0, (emoji) => {
    onAddReaction(messageKey, emoji, conversationKey)
    setIsPickerOpen(false)
  }, [onAddReaction, messageKey, conversationKey])
  // As for a lone message: only a delivered one can be replied to or recalled,
  // and an image still waiting for consent can be recalled by any teammate
  // (master D-108), even in an SMS chat.
  const isAwaitingConsent = !!_optionalChain([row, 'access', _7 => _7.SMSDeliveryOutcomes, 'optionalAccess', _8 => _8.some, 'call', _9 => _9(o => o.Status === _consent.SMS_AWAITING_CONSENT_STATUS)])
  const canDelete = ((isFromMe && !recallOnlyAwaitingConsent) || isAwaitingConsent) && delivered
  const handleReply = _react.useMemo.call(void 0, 
    () => !readOnly && delivered && onReply ? () => onReply(row) : null,
    [readOnly, delivered, onReply, row],
  )
  const handleDelete = _react.useMemo.call(void 0, 
    () => canDelete && onDelete ? () => onDelete(messageKey, conversationKey) : null,
    [canDelete, onDelete, messageKey, conversationKey],
  )
  const handleCopyMessageLink = _react.useCallback.call(void 0, 
    () => onCopyMessageLink(messageKey),
    [onCopyMessageLink, messageKey],
  )
  // Only a delivered image can be downloaded, as for a lone file.
  const handleDownload = _react.useMemo.call(void 0, 
    () => fileKey && delivered ? () => onDownload(fileKey) : null,
    [fileKey, delivered, onDownload],
  )
  const info = row.FileInfo
  const isVideo = _Lightbox.isVideoRow.call(void 0, row)
  const kindLabel = isVideo ? 'video' : 'image'

  return (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 'image-group--tile', {
        'image-group--tile-full': isFullWidth,
        'image-group--tile-active': isMenuOpen || isPickerOpen,
      }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}

      , _react2.default.createElement(_DerivativeImage2.default, {
        className: "image-group--image",
        blurHash: _optionalChain([info, 'optionalAccess', _10 => _10.BlurHash]),
        // The sender's own copy may show its local preview before the thumbnail exists.
        thumbnailUrl: _optionalChain([info, 'optionalAccess', _11 => _11.ThumbnailURL]) || _optionalChain([info, 'optionalAccess', _12 => _12.PreviewUrl]),
        width: _optionalChain([info, 'optionalAccess', _13 => _13.ImageWidth]),
        height: _optionalChain([info, 'optionalAccess', _14 => _14.ImageHeight]),
        fileName: moreCount
          ? `${row.FileName}, ${kindLabel} ${index + 1} of ${count}, and ${moreCount} more`
          : `${row.FileName}, ${kindLabel} ${index + 1} of ${count}`,
        onRequestFreshThumbnail: requestFreshThumbnail,
        onOpenOriginal: handleOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}

        /* A video with no thumbnail yet shows the blank tile with its play icon. */
        ,  isVideo && !moreCount && _react2.default.createElement(_VideoOverlay2.default, { durationMs: _optionalChain([info, 'optionalAccess', _15 => _15.DurationMs]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}} ) 
        ,  moreCount > 0 && _react2.default.createElement('div', { className: "image-group--more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}, "+", moreCount) 
      )
      ,  !delivered && !moreCount && (
        _react2.default.createElement(TileUploadState, { row: row, messageKey: messageKey, isFromMe: isFromMe, onRetry: onRetry, onAbort: onAbort, __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}} )
      )
      , _react2.default.createElement('div', { className: "image-group--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
        ,  !readOnly && (
          _react2.default.createElement(_Tooltip.ControlledTooltip, {
            place: isFromMe ? 'left' : 'right',
            isOpen: isPickerOpen,
            onClose: closePicker,
            content: isPickerOpen ? _react2.default.createElement(_ReactionPicker2.default, { onSelect: handleSelectReaction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}} ) : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}

            , _react2.default.createElement('button', {
              type: "button",
              className: "image-group--action",
              onClick: openPicker,
              'aria-label': "Add reaction" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}

              , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}}, "add_reaction")
            )
          )
        )
        , _react2.default.createElement(_Tooltip.ControlledTooltip, {
          place: isFromMe ? 'left' : 'right',
          isOpen: isMenuOpen,
          onClose: closeMenu,
          content: (
            _react2.default.createElement(_ContextMenu2.default, {
              onClose: closeMenu,
              onReply: handleReply,
              onCopy: null,
              onSaveAsTemplate: null,
              onTranslate: null,
              translating: false,
              onDelete: handleDelete,
              onCopyMessageLink: handleCopyMessageLink,
              onDownload: handleDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}
            )
          ),
          className: "inbox-participants--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}

          , _react2.default.createElement('button', {
            type: "button",
            className: "image-group--action",
            onClick: openMenu,
            'aria-label': "Message actions" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}

            , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}, "more_horiz")
          )
        )
      )
      , _react2.default.createElement('div', { className: "image-group--reactions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}
        , _react2.default.createElement(_ReactionChips2.default, {
          reactions: row.Reactions,
          currentUserKey: currentUserKey,
          messageKey: messageKey,
          conversationKey: conversationKey,
          deleted: !!row.Deleted,
          subscribers: subscribers,
          onAddReaction: onAddReaction,
          onRemoveReaction: onRemoveReaction,
          readOnly: readOnly, __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
        )
      )
    )
  )
}














const noop = () => undefined

/* Consecutive images from one sender, shown as one grid bubble. Each tile is
 * its own message: click opens the viewer at it, and its reactions and
 * actions sit on it. */
const ImageGroupMessage = ({
  group, onReply, caption, onReplyCaption, onRetry, onAbort,
  ...wrapperProps
}) => {
  const {
    senderKey, currentUserKey, subscribers, conversationKey, readOnly,
    onAddReaction, onRemoveReaction, onCopyMessageLink, onDelete, recallOnlyAwaitingConsent,
  } = wrapperProps
  const isFromMe = senderKey === currentUserKey
  // The caption is a part of the bubble: hovering it points the row's
  // buttons at it. The tiles carry their own.
  const captionPart = _CaptionPart.useCaptionPart.call(void 0, caption, false, onReplyCaption)
  const [expanded, setExpanded] = _react.useState.call(void 0, false)
  const [openKey, setOpenKey] = _react.useState(null)
  const expand = _react.useCallback.call(void 0, () => setExpanded(true), [])
  const closeLightbox = _react.useCallback.call(void 0, () => setOpenKey(null), [])
  const { download, downloadNode } = _useFileDownload2.default.call(void 0, currentUserKey)
  const rows = _imageGrid.imageGridRows.call(void 0, group.length, expanded)
  const moreCount = _imageGrid.hiddenImageCount.call(void 0, group.length, expanded)
  const lastShown = rows[rows.length - 1].slice(-1)[0]
  // Each tile shows its own failure and Retry; the bubble shows only that
  // the send is still going out.
  const groupStatus = group.some(row => row.deliveryStatus === _message.deliveryStatus.SENT)
    ? _message.deliveryStatus.SENT
    : _message.deliveryStatus.DELIVERED

  return (
    _react2.default.createElement(_RichMessageWrapper2.default, {
      ...wrapperProps,
      deliveryStatus: groupStatus,
      onRetry: noop,
      onCopy: null,
      part: captionPart,
      // Each tile shows its own reactions, the newest image's included.
      reactions: undefined,
      hideActions: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 318}}

      , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'image-group', isFromMe ? 'image-group--me' : 'image-group--them'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 328}}
        ,  rows.map(indexes => (
          _react2.default.createElement('div', { key: indexes[0], className: "image-group--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 330}}
            ,  indexes.map(i => (
              _react2.default.createElement(ImageTile, {
                key: group[i].MessageKey,
                row: group[i],
                index: i,
                count: group.length,
                isFullWidth: indexes.length === 1,
                moreCount: i === lastShown ? moreCount : 0,
                isFromMe: isFromMe,
                currentUserKey: currentUserKey,
                subscribers: subscribers,
                conversationKey: conversationKey,
                readOnly: readOnly,
                recallOnlyAwaitingConsent: recallOnlyAwaitingConsent,
                onOpen: setOpenKey,
                onExpand: expand,
                onAddReaction: onAddReaction,
                onRemoveReaction: onRemoveReaction,
                onReply: onReply,
                onDelete: onDelete,
                onCopyMessageLink: onCopyMessageLink,
                onDownload: download,
                onRetry: onRetry,
                onAbort: onAbort, __self: this, __source: {fileName: _jsxFileName, lineNumber: 332}}
              )
            ))
          )
        ))
        ,  caption && (
          _react2.default.createElement(_CaptionPart2.default, {
            caption: caption,
            className: "image-group--caption",
            currentUserKey: currentUserKey,
            subscribers: subscribers,
            conversationKey: conversationKey,
            onAddReaction: onAddReaction,
            onRemoveReaction: onRemoveReaction,
            readOnly: readOnly, __self: this, __source: {fileName: _jsxFileName, lineNumber: 360}}
          )
        )
      )
      ,  openKey !== null && (
        _react2.default.createElement(_Lightbox2.default, {
          group: group,
          initialMessageKey: openKey,
          onClose: closeLightbox,
          requestOriginal: requestFileLinks,
          onDownload: download, __self: this, __source: {fileName: _jsxFileName, lineNumber: 373}}
        )
      )
      , downloadNode
    )
  )
}

exports. default = ImageGroupMessage
